export default {"src":"/_next/static/media/wallet.9df2c29b.svg","height":16,"width":16};